<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 维保任务
        </span>
        <div class="w_normalNav" :parent="self">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
          <button class="BlueSmBtn" @click="downloadDialog = true">批量导出</button>
        </div>
        <div class="searchForm1">
          <searchForm :items="items" :formPlus="form_jsgl" ref="searchForm_jsgl">
            <template slot="last">
              <el-form-item label="任务名称:">
                <el-input v-model="seefrom.taskName" placeholder="请输入任务名称"></el-input>
              </el-form-item>
              <el-form-item label="维保项目:">
                <el-select :popper-append-to-body="false" v-model="seefrom.projectId" placeholder="请选择维保项目" style="width:100%">
                  <el-option v-for="item in projectList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="维保单位:">
                <el-input v-model="seefrom.deptName" placeholder="请输入单位名称"></el-input>
              </el-form-item>
              <el-form-item label="维保类型:">
                <el-select :popper-append-to-body="false" v-model="seefrom.type" placeholder="请选择维保类型" style="width:100%">
                  <el-option v-for="(item,index) in typeList" :key="index" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <br />
              <el-form-item label="楼宇类型:" v-if="companyType != 3">
                <el-select :popper-append-to-body="false" v-model="seefrom.buildType" placeholder="请选择楼宇类型" style="width:100%">
                  <el-option v-for="(item,index) in buildTypeList" :key="index" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="开始时间:">
                <el-date-picker v-model="seefrom.startTime" value-format="yyyy-MM-dd" type="date" placeholder="请选择开始时间">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="结束时间:">
                <el-date-picker v-model="seefrom.endTime" value-format="yyyy-MM-dd" type="date" placeholder="请选择结束时间">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="维保状态:">
                <el-select :popper-append-to-body="false" v-model="seefrom.status" placeholder="请选择维保状态" style="width:100%">
                  <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </template>
          </searchForm>
        </div>
        <div class="tableWrapper">
          <el-table :data="tableData" style="width: 100%" class="stripeTable" height="500" ref="Table">
            <el-table-column show-overflow-tooltip :label="label" :prop="prop" :align="align" :width="width" v-for="({prop,label,align, width}) in config" :key="prop.toString()"></el-table-column>
            <el-table-column label="操作" width="170">
              <template slot-scope="scope">
                <el-link icon="iconfont iconcheck" type="text" size="small" @click="check(scope.$index,  scope.row)">详情
                </el-link>
                <el-link icon="iconfont iconedit" type="text" size="small" @click="download(scope.$index, scope.row)" v-if="scope.row.status != 0">导出</el-link>
              </template>
            </el-table-column>
          </el-table>
          <div class="footer">
            <el-pagination layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100]" :page-size="10" @current-change="handleCurrentChange" :total="nTotal"
              :current-page="currentPage" @size-change="sizeChangeHandle">
            </el-pagination>
          </div>
        </div>
        <el-dialog class="taskDetailDialog" :visible.sync="commandDialog" :close-on-click-modal="false" width="70%" height="70%">
          <div class="titleContainer">
            <div class="titleItem" :class="{'active': activeName == 'base' }" @click="changeTab('base')">详情</div>
            <div class="titleItem" :class="{'active': activeName == 'content' }" @click="changeTab('content')">{{ formDetail.status == 0 ? '巡检内容' : '巡检结果' }}</div>
          </div>
          <keep-alive>
            <template v-if="activeName === 'base'">
              <el-form class="adddevice" ref="base" :model="base" style="padding: 0; margin-top: 20px" label-width="100px">
                <el-form-item prop="taskName" label="任务名称">
                  <p>{{ base.taskName }}</p>
                </el-form-item>
                <el-form-item prop="createTime" label="创建时间">
                  <p>{{ base.createTime }}</p>
                </el-form-item>
                <el-form-item prop="buildType" label="楼宇类型" v-if="companyType != 3">
                  <p>{{ base.buildType }}</p>
                </el-form-item>
                <el-form-item prop="type" label="维保类型">
                  <p>{{ base.type }}</p>
                </el-form-item>
                <el-form-item prop="deptName" label="维保单位">
                  <p>{{ base.deptName }}</p>
                </el-form-item>
                <el-form-item prop="departmentContacts" label="单位联系人">
                  <p>{{ base.departmentContacts }}</p>
                </el-form-item>
                <el-form-item prop="departmentContactsPhone" label="联系人手机号">
                  <p>{{ base.departmentContactsPhone }}</p>
                </el-form-item>
                <el-form-item prop="areaName" label="维保区域">
                  <p>{{ base.areaName }}</p>
                </el-form-item>
                <el-form-item prop="month" label="维保月份">
                  <p>{{ base.month }}</p>
                </el-form-item>
                <el-row>
                  <el-col :span="6" style="height:50px;display: flex; align-items: center">
                    <el-form-item label="执行状态" style="display: flex; align-items: center">
                      <span :class="getStatusClass(formDetail.status)" class="statusMark">{{ formDetail.status == 0 ? '未执行' : '已执行' }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8" style="height:50px;display: flex; align-items: center">
                    <el-form-item prop="implTime" label="维保时间">
                      <p>{{ formDetail.implTime }}</p>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4" style="height:50px;display: flex; align-items: center">
                    <el-form-item prop="contactPerson" label="维保人">
                      <p>{{ formDetail.contactPerson }}</p>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6" style="height:50px;display: flex; align-items: center">
                    <el-form-item label="签名" style="display: flex; align-items: center">
                      <el-image :src="formDetail.signPic" style="width: 100px;background: white" v-if="formDetail.isSign === 1 && formDetail.status != 0" :preview-src-list="[formDetail.signPic]">
                        <div slot="placeholder" class="image-slot">
                          加载中<span class="dot">...</span>
                        </div>
                      </el-image>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </template>
            <template v-else>
              <template v-if="base.status == 0">
                <el-table :data="taskResultList" style="margin:20px 0" class="stripeTable" height="300" ref="Table">
                  <el-table-column label="部位" prop="position" show-overflow-tooltip></el-table-column>
                  <el-table-column label="消防系统" prop="fireControlSystem" show-overflow-tooltip></el-table-column>
                  <el-table-column label="巡检内容" prop="patrolContent" show-overflow-tooltip></el-table-column>
                  <el-table-column label="建设交付情况" prop="deliverContent" show-overflow-tooltip></el-table-column>
                  <el-table-column label="检查标准" prop="inspectionStandard" show-overflow-tooltip></el-table-column>
                  <el-table-column label="检查方法" prop="inspectionMethod" show-overflow-tooltip></el-table-column>
                  <el-table-column label="检查结果" prop="inspectionResult" show-overflow-tooltip></el-table-column>
                  <el-table-column label="问题详情" prop="remark" show-overflow-tooltip></el-table-column>
                  <el-table-column label="维修结果" prop="maintenanceContent" show-overflow-tooltip></el-table-column>
                </el-table>
              </template>
              <template v-else>
                <table style="width: 100%;" class="customTable">
                  <thead>
                    <tr style="width: 100%;">
                      <th style="width: 8.11%; display: inline-block;text-align: center;">部位</th>
                      <th style="width: 11.11%; display: inline-block;text-align: center;">消防系统</th>
                      <th style="width: 11.11%; display: inline-block;text-align: center;">巡检内容</th>
                      <th style="width: 11.11%; display: inline-block;text-align: center;">建设交付情况</th>
                      <th style="width: 11.11%; display: inline-block;text-align: center;">检查标准</th>
                      <th style="width: 10.11%; display: inline-block;text-align: center;">检查方法</th>
                      <th style="width: 10.11%; display: inline-block;text-align: center;">检查结果</th>
                      <th style="width: 13.11%; display: inline-block;text-align: center;">问题详情</th>
                      <th style="width: 13.11%; display: inline-block;text-align: center;">维修结果</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item,index) in taskResultList" :key="index" style="width: 100%;">
                      <td style="width: 8.11%;display: inline-block;text-align: center;">
                        <custom-tip :content="item.position" max-width="100%"></custom-tip>
                      </td>
                      <td style="width: 11.11%;display: inline-block;text-align: center;">
                        <custom-tip :content="item.fireControlSystem" max-width="100%"></custom-tip>
                      </td>
                      <td style="width: 11.11%;display: inline-block;text-align: center;">
                        <custom-tip :content="item.patrolContent" max-width="100%"></custom-tip>
                      </td>
                      <td style="width: 11.11%;display: inline-block;text-align: center;">
                        <custom-tip :content="item.deliverContent" max-width="100%"></custom-tip>
                      </td>
                      <td style="width: 11.11%;display: inline-block;text-align: center;">
                        <custom-tip :content="item.inspectionStandard" max-width="100%"></custom-tip>
                      </td>
                      <td style="width: 10.11%;display: inline-block;text-align: center;">
                        <custom-tip :content="item.inspectionMethod" max-width="100%"></custom-tip>
                      </td>
                      <td style="width: 10.11%;display: inline-block;text-align: center;">
                        <custom-tip :content="item.inspectionResult" max-width="100%"></custom-tip>
                      </td>
                      <td style="width: 13.11%;display: inline-block;text-align: center;">
                        <custom-tip :content="item.remark" max-width="100%"></custom-tip>
                      </td>
                      <td style="width: 13.11%;display: inline-block;text-align: center;">
                        <custom-tip :content="item.maintenanceContent" max-width="100%"></custom-tip>
                      </td>
                      <td v-if="item.fileUrl" style="width: 100%;display: flex; justify-content: center; flex-wrap: wrap;">
                        <div v-for="(bitem, index) in item.fileUrl.split(',')" :key="index" style="">
                          <div>
                            <el-image :src="bitem" :preview-src-list="item.fileUrl.split(',').filter((items) => !['mp4'].includes(items.substr(items.lastIndexOf('.') + 1)))"
                              style="width: 60px; height: 60px;margin: 0 10px 10px 0;" v-if="!['mp4'].includes(bitem.substr(bitem.lastIndexOf('.') + 1))">
                              <div slot="placeholder" class="image-slot">
                                加载中<span class="dot">...</span>
                              </div>
                            </el-image>
                            <video :src="bitem" style="width: 60px; height: 60px;margin: 0 10px 10px 0;" v-else @click="openVideo(bitem)"></video>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </template>
            </template>
          </keep-alive>
        </el-dialog>
      </el-tab-pane>
      <download-dialog v-model="downloadDialog"></download-dialog>
      <el-dialog class="editDialog" :visible.sync="videoDialog" :close-on-click-modal="false">
        <div slot="footer" class="dialog-footer">
          <video :src="videoUrl" style="height: 100%;width: 100%" controls type="video/mp4" />
        </div>
      </el-dialog>
    </el-tabs>
  </div>
</template>

<script>
import { date } from 'utils'
export default {
  data() {
    return {
      form_jsgl: {},
      items: [],
      rules: {},
      buildTypeList: [
        {
          label: '低层',
          value: '低层'
        },
        {
          label: '高层',
          value: '高层'
        }
      ],
      title: '详情',
      tabName: 'jsgl',
      commandDialog: false,
      seefrom: {},
      base: {},
      tableData: [],
      nTotal: 0,
      currentPage: 1,
      currentSize: 10,
      projectList: [],
      departmentList: [],
      taskResultList: [],
      activeName: 'base',
      formDetail: {},
      downloadDialog: false,
      videoUrl: '',
      videoDialog: false,
      companyType: localStorage.getItem('companyType')
    }
  },
  computed: {
    self() {
      return this
    },
    config() {
      if (this.companyType == 3) {
        return [
          {
            prop: 'createTime',
            label: '创建时间'
          },
          {
            prop: 'taskName',
            label: '任务名称',
            width: 330
          },
          {
            prop: 'projectName',
            label: '维保项目'
          },
          {
            prop: 'deptName',
            label: '维保单位'
          },
          {
            prop: 'type',
            label: '维保类型'
          },
          {
            prop: 'month',
            label: '月份'
          },
          {
            prop: 'statusName',
            label: '状态'
          },
          {
            prop: 'implTime',
            label: '完成时间'
          }
        ]
      } else {
        return [
          {
            prop: 'createTime',
            label: '创建时间'
          },
          {
            prop: 'taskName',
            label: '任务名称',
            width: 330
          },
          {
            prop: 'projectName',
            label: '维保项目'
          },
          {
            prop: 'deptName',
            label: '维保单位'
          },
          {
            prop: 'type',
            label: '维保类型'
          },
          {
            prop: 'month',
            label: '月份'
          },
          {
            prop: 'buildType',
            label: '楼宇类型'
          },
          {
            prop: 'statusName',
            label: '状态'
          },
          {
            prop: 'implTime',
            label: '完成时间'
          }
        ]
      }
    },
    typeList() {
      if (this.companyType == 3) {
        return [
          {
            label: '日检',
            value: '日检'
          },
          {
            label: '周检',
            value: '周检'
          },
          {
            label: '月检',
            value: '月检'
          },
          {
            label: '季检',
            value: '季检'
          },
          {
            label: '年检',
            value: '年检'
          }
        ]
      } else {
        return [
          {
            label: '月检',
            value: '月检'
          },
          {
            label: '季检',
            value: '季检'
          },
          {
            label: '年检',
            value: '年检'
          }
        ]
      }
    },
    statusList() {
      if (this.companyType == 3) {
        return [
          {
            label: '全部',
            value: undefined
          },
          {
            label: '未执行',
            value: 0
          },
          {
            label: '已完成',
            value: 2
          }
        ]
      } else {
        return [
          {
            label: '全部',
            value: undefined
          },
          {
            label: '未执行',
            value: 0
          },
          {
            label: '已执行',
            value: 1
          },
          {
            label: '已完成',
            value: 2
          }
        ]
      }
    }
  },
  components: {
    normalNav: () => import('public/normalNav'),
    searchForm: () => import('public/searchForm'),
    easyTable: () => import('public/easyTable'),
    customTip: () => import('./customTip'),
    downloadDialog: () => import('./downloadDialog/index')
  },
  methods: {
    getProjectList() {
      this.$axiosget('extra/maintenanceProject').then((res) => {
        if (res.data.status === 10000) {
          this.projectList = res.data.data
        }
      })
    },
    //搜索
    subSeefrom() {
      this.currentPage = 1
      this.getTableData()
    },
    //重置
    reset() {
      this.seefrom = {}
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getTableData()
    },
    // 每页数
    sizeChangeHandle(val) {
      this.currentSize = val
      this.currentPage = 1
      this.getTableData()
    },
    isMaxGtMin() {
      if (!this.seefrom.startTime || !this.seefrom.endTime) return true
      let s = date(this.seefrom.startTime)
      let e = date(this.seefrom.endTime)
      let ns = [s.YY, s.MM, s.DD].join('')
      let ne = [e.YY, e.MM, e.DD].join('')
      return ne > ns ? true : false
    },
    //查询表格数据
    getTableData() {
      if (this.seefrom.startTime && this.seefrom.endTime) {
        if (!this.isMaxGtMin()) {
          this.$notify({
            message: '开始时间需小于结束时间',
            type: 'warning'
          })
          return
        }
      }
      this.$axiosget('extra/maintenanceTask/page', {
        params: {
          pageSize: this.currentSize,
          pageNum: this.currentPage,
          ...this.seefrom,
          startTime: this.seefrom.startTime
            ? this.seefrom.startTime + ' 00:00:00'
            : undefined,
          endTime: this.seefrom.endTime
            ? this.seefrom.endTime + ' 23:59:59'
            : undefined,
          status: this.seefrom.status
        }
      }).then((res) => {
        this.tableData = res.data.data.list
        this.nTotal = res.data.data.total
      })
    },
    check(index, row) {
      this.$axiosget('extra/maintenanceTask/detail', {
        params: {
          id: row.id
        }
      }).then((res) => {
        if (res.data.data.taskResultList.length) {
          res.data.data.taskResultList.forEach((item) => {
            if (item.enclosure) {
              item.fileUrl = item.fileUrl
                ? item.fileUrl + ',' + item.enclosure
                : item.enclosure
            }
            if (item.maintenanceFile) {
              item.fileUrl = item.fileUrl
                ? item.fileUrl + ',' + item.maintenanceFile
                : item.maintenanceFile
            }
            if (item.fileUrl) {
              let fileUrl = item.fileUrl.split(',').map((bitem) => {
                let fileUrl = process.env.fileUrl
                if (bitem && bitem.includes(fileUrl)) {
                  if (
                    process.env.SSL_ENABLE ||
                    process.env.SSL_ENABLE === 'true'
                  ) {
                    return bitem.replaceAll(
                      fileUrl,
                      process.env.SSL_HOST + '/file/'
                    )
                  } else {
                    return bitem
                  }
                } else {
                  return bitem
                }
              })
              if (fileUrl.length > 0) {
                item.fileUrl = fileUrl.join(',')
              }
            }
          })
          this.taskResultList = res.data.data.taskResultList
        } else {
          this.taskResultList = res.data.data.projectItemList
        }
        this.formDetail = res.data.data
        if (this.formDetail.signPic && this.formDetail.isSign === 1) {
          let fileUrl = process.env.fileUrl
          if (
            this.formDetail.signPic &&
            this.formDetail.signPic.includes(fileUrl)
          ) {
            if (process.env.SSL_ENABLE || process.env.SSL_ENABLE === 'true') {
              this.formDetail.signPic = this.formDetail.signPic.replaceAll(
                fileUrl,
                process.env.SSL_HOST + '/file/'
              )
            }
          }
        }
        this.base = row
        this.activeName = 'base'
        this.commandDialog = true
      })
    },
    openVideo(val) {
      this.videoUrl = val
      this.videoDialog = true
    },
    getStatusClass(val) {
      if (val == 0) {
        return 'unExecte'
      } else {
        return 'exected'
      }
    },
    changeTab(val) {
      this.activeName = val
    },
    download(index, row) {
      this.$axiospost(
        `extra/maintenanceTask/export/list?id=${
          row.id
        }&companyId=${localStorage.getItem('companyId')}`
      ).then((res) => {
        // loading.close()
        this.$message.success('下载成功!')
      })
    }
  },
  created() {
    this.getTableData()
  },
  mounted() {
    this.getProjectList()
  }
}
</script>

<style lang="less">
.w_normalNav {
  padding-top: 10px;
  height: 52px;
  position: absolute;
  top: -52px;
  right: 32px;
  z-index: 99;
}
.el-input__inner:focus {
  border: 1px solid #3587c7;
}
</style>

<style lang="less" scoped>
/deep/ .el-pagination {
  .el-pagination__total {
    color: #b5b5b5;
  }

  .el-pagination__jump {
    color: #b5b5b5;
  }

  .el-select .el-input .el-input__inner,
  .el-pagination__jump .el-input .el-input__inner {
    background-color: #2e3657;
    border-color: rgba(221, 221, 221, 0.2);
    color: #f5f5f5;
  }
}

/deep/ .taskDetailDialog {
  .el-dialog__body {
    padding-top: 10px;
  }

  .titleContainer {
    display: flex;
    background: #2e3657;
    border: 1px solid #214c71;

    & > div {
      width: 100px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      color: #c0c4cc;
      cursor: pointer;

      &.active {
        background: #262d4a;
        color: #409eff;
      }
    }
  }

  .el-form-item {
    margin-bottom: 12px;
  }

  .el-form-item__content {
    margin-left: 0 !important;
  }
}

.statusMark {
  padding: 2px 5px;
  color: #fff;
}

.unExecte {
  background: #e03b38;
}

.exected {
  background: #3fa25a;
}

.customTable {
  margin-top: 20px;
  overflow-y: hidden;
  position: relative;
  width: 100%;

  /* 固定表头 */
  thead,
  tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
  }

  /* 控制表格滑动 */
  tbody {
    display: block;
    height: 45.2vh;
    overflow-y: scroll;
  }

  thead {
    background: #2e3657;
  }

  thead th {
    height: 42px;
    line-height: 42px;
    font-size: 16px;
    color: #fff;
  }

  tbody tr {
    font-size: 14px;
    color: #ccc;

    &:nth-child(2n - 1) {
      background: transparent;
    }

    &:nth-child(2n) {
      background: rgb(34, 41, 61);
    }

    td {
      padding: 5px 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/wbManage/wbTask/index.vue